import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { cambiarContrasenia } from 'store/slices/userSlice';
import { useAppDispatch } from 'store';

type State = {
  password: string;
  passwordConfirm: string;
  showPassword: boolean;
  showPasswordConfirm: boolean;
};

type DialogProps = {
  openDialog: boolean;
  handleDialogClose: () => void;
};

const FormChangeDialog = ({ openDialog, handleDialogClose }: DialogProps) => {
  const { t } = useTranslation();
  // const notify = useNotify();
  const [values, setValues] = React.useState<State>({
    password: '',
    passwordConfirm: '',
    showPassword: false,
    showPasswordConfirm: false,
  });
  const [isDirty, setIsDirty] = useState(false);
  const [error] = useState<unknown>('');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const showPasswordError = isDirty && values.password === '';

  const showPasswordConfirmError =
    isDirty &&
    (values.passwordConfirm === '' ||
      values.password !== values.passwordConfirm);

  const handleInputChange =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({ ...values, [prop]: event.target.value });
      // setIsDirty(true);
    };

  const handleInputChange2 =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({ ...values, [prop]: event.target.value });
      // setIsDirty(true);
    };

  const handleShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleShowPasswordConfirm = () => {
    setValues({ ...values, showPasswordConfirm: !values.showPasswordConfirm });
  };

  const handleGuardar = () => {
    console.log(' >>> handleGuardar');
    if (isLoading) return;

    if (values.password !== values.passwordConfirm) {
      setIsDirty(true);
      return;
    }

    setIsLoading(true);
    // alert('guardar');
    const onComplete = (success: boolean) => {
      console.log('complete??? success = ', success);
      setIsLoading(false);
      if (!success) {
        return;
      }
      setValues({
        password: '',
        passwordConfirm: '',
        showPassword: false,
        showPasswordConfirm: false,
      });
      setIsDirty(false);
      handleDialogClose();
    };
    void dispatch(cambiarContrasenia(values.password)).then((result) => {
      if (cambiarContrasenia.fulfilled.match(result)) {
        onComplete(Boolean(result.payload));
      } else {
        onComplete(false);
      }
    });
  };

  return (
    <form>
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {t('restablecimientoContrasenia')}
        </DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              borderRadius: '25px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              maxWidth: '380px',
            }}
          >
            <>
              <Typography variant="subtitle2">
                {t('crearNuevaContrasenia')}
              </Typography>
              <FormControl
                sx={{ mt: 2 }}
                variant="outlined"
                error={showPasswordError}
              >
                <InputLabel htmlFor="outlined-adornment-password">
                  {t('contrasenia')} *
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  label={`${t('contrasenia')} *`}
                  type={values.showPassword ? 'text' : 'password'}
                  value={values.password}
                  onChange={handleInputChange('password')}
                  required
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleShowPassword}
                        sx={showPasswordError ? { color: 'error.main' } : {}}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {showPasswordError ? (
                  <FormHelperText id="component-error-text">
                    {t('form.required')} *
                  </FormHelperText>
                ) : (
                  ''
                )}
              </FormControl>
              <FormControl
                sx={{ mt: 2 }}
                variant="outlined"
                error={showPasswordConfirmError}
              >
                <InputLabel htmlFor="outlined-adornment-password-confirm">
                  {t('confirmarContrasenia')} *
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password-confirm"
                  label={`${t('confirmarContrasenia')} *`}
                  type={values.showPasswordConfirm ? 'text' : 'password'}
                  value={values.passwordConfirm}
                  onChange={handleInputChange2('passwordConfirm')}
                  required
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle passwordConfirm visibility"
                        onClick={handleShowPasswordConfirm}
                        sx={
                          showPasswordConfirmError
                            ? { color: 'error.main' }
                            : {}
                        }
                        edge="end"
                      >
                        {values.showPasswordConfirm ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {showPasswordConfirmError ? (
                  <FormHelperText id="component-error-text-password">
                    {t('contraseniaNoCoincide')} *
                  </FormHelperText>
                ) : (
                  ''
                )}
              </FormControl>
              <Box sx={{ mt: 1 }}>
                {error ? (
                  <Typography variant="caption" sx={{ color: 'error.main' }}>
                    {error instanceof Error
                      ? error.message
                      : typeof error === 'string'
                        ? error
                        : ''}
                  </Typography>
                ) : null}
              </Box>
            </>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            p: 2,
          }}
        >
          <Button
            variant="contained"
            color="inherit"
            onClick={() => handleDialogClose()}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', width: '30px' }}>
              <CloseIcon fontSize="small" sx={{ mr: 0.5, mb: -0.5 }} />
            </Box>
            {t('form.cerrar')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleGuardar()}
            disabled={
              showPasswordError ||
              showPasswordConfirmError ||
              values.password === ''
            }
          >
            <Box sx={{ display: 'flex', alignItems: 'center', width: '30px' }}>
              {isLoading && <CircularProgress size={18} color="inherit" />}
              {!isLoading && (
                <CheckIcon fontSize="small" sx={{ mr: 0.5, mb: -0.5 }} />
              )}
            </Box>
            {t('form.guardar')}
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
};

export default FormChangeDialog;
